import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";
import { ResultsLandingPage } from "./pages/ResultsLandingPage/ResultsLandingPage";

const ResultsModule = React.lazy(() => import("./ResultsModule"));
const ResultsAllPage = React.lazy(() => import("./pages/ResultsAllPage/ResultsAllPage"));
const ResultsQualQuestionPage = React.lazy(
  () => import("./pages/ResultsQualQuestionPage/ResultsQualQuestionPage"),
);
const ResultsTextQuestionPage = React.lazy(
  () => import("./pages/ResultsTextQuestionPage/ResultsTextQuestionPage"),
);
const ResultsDriversPage = React.lazy(
  () => import("./pages/ResultsTextQuestionPage/ResultsDriversPage/ResultsDriversPage"),
);
const ResultsSingleConceptPage = React.lazy(
  () => import("./pages/ResultsSingleConcept/ResultsSingleConcept"),
);
const ResultsAdvertisingPage = React.lazy(
  () => import("./pages/ResultsAdvertisingPage/ResultsAdvertisingPage"),
);
const ResultsNpdOverview = React.lazy(() => import("./pages/ResultsNpdOverview/ResultsNpdOverview"));
const ResultsDemographicsPage = React.lazy(
  () => import("./pages/ResultsDemographicsPage/ResultsDemographicsPage"),
);
const ResultsH2HPage = React.lazy(() => import("./pages/ResultsH2HPage/ResultsH2HPage"));

const ResultsSummaryPage = React.lazy(() => import("./pages/ResultsSummaryPage/ResultsSummaryPage"));

const ResultsPriceSensitivity = React.lazy(
  () => import("./pages/ResultsPriceSensitivity/ResultsPriceSensitivity"),
);

const ResultsMarketReachPage = React.lazy(
  () => import("./pages/ResultsMarketReachPage/ResultsMarketReachPage"),
);
const ResultsSurveyProgressPage = React.lazy(
  () => import("./pages/ResultsSurveyProgressPage/ResultsSurveyProgressPage"),
);
const ResultsDownloadsPage = React.lazy(() => import("./pages/ResultsDownloadsPage/ResultsDownloadsPage"));
const ResultsCreateNarrativePage = React.lazy(
  () => import("./pages/ResultsCreateNarrativePage/ResultsCreateNarrativePage"),
);
const ResultsPresentationViewPage = React.lazy(
  () => import("./pages/ResultsPresentationViewPage/ResultsPresentationViewPage"),
);

export const ResultModuleRoutes: RouteObject = {
  path: ":clientId/results/:projectId/*",
  element: <ModuleRoute El={ResultsModule} moduleName="results" blockWhenChurned />,
  children: [
    {
      path: "summary",
      element: <PageRoute El={ResultsSummaryPage} />,
    },
    {
      path: "demographics/:tab?",
      element: <PageRoute El={ResultsDemographicsPage} />,
    },
    {
      path: "advertising",
      element: <PageRoute El={ResultsAdvertisingPage} />,
    },
    {
      path: "npd-qual/:projectQuestionId",
      element: <PageRoute El={ResultsQualQuestionPage} />,
    },
    {
      path: "npd-text/:projectQuestionId",
      element: <PageRoute El={ResultsTextQuestionPage} />,
    },
    {
      path: "qual/:projectQuestionId/:tab?",
      element: <PageRoute El={ResultsQualQuestionPage} />,
    },
    {
      path: "wave/:projectQuestionId",
      element: <PageRoute El={ResultsQualQuestionPage} />,
    },
    {
      path: "text/:projectQuestionId/:tab?",
      element: <PageRoute El={ResultsTextQuestionPage} />,
    },
    {
      path: "drivers/:projectQuestionId", /// diagnose
      element: <PageRoute El={ResultsDriversPage} />,
    },
    {
      path: "grow-ideas/:testOptionId/:tab?", /// diagnose
      element: <PageRoute El={ResultsSingleConceptPage} />,
    },
    {
      path: "h2h/:tab", /// h2h
      element: <PageRoute El={ResultsH2HPage} />,
    },
    {
      path: "segment-question/:projectQuestionId",
      element: <PageRoute El={ResultsQualQuestionPage} />,
    },
    {
      path: "profile-question/:projectQuestionId",
      element: <PageRoute El={ResultsQualQuestionPage} />,
    },
    {
      path: "price-sensitivity",
      element: <PageRoute El={ResultsPriceSensitivity} />,
    },
    {
      path: "market-reach/:tab?",
      element: <PageRoute El={ResultsMarketReachPage} ff={"MarketReach"} />,
    },
    {
      path: "npd", /// ALL
      element: <PageRoute El={ResultsNpdOverview} />,
    },
    {
      path: "narratives/:narrativeId",
      element: <PageRoute El={ResultsCreateNarrativePage} />,
    },
    {
      path: "narratives/:narrativeId/presentations/:exportId",
      element: <PageRoute El={ResultsPresentationViewPage} />,
    },
    {
      path: "survey-progress",
      element: <PageRoute El={ResultsSurveyProgressPage} />,
    },
    {
      path: "downloads",
      element: <PageRoute El={ResultsDownloadsPage} />,
    },
    {
      path: "",
      element: <ResultsLandingPage />,
    },
    {
      path: ":tab", /// ALL
      element: <PageRoute El={ResultsAllPage} />,
    },
  ],
};
